<template>
  <div>
    <CoreSurvey />
  </div>
</template>

<script>
import CoreSurvey from "@/components/CoreSurvey.vue";
import FullPageLayout from "../layouts/FullPageLayout";

export default {
  components: {
    CoreSurvey
  },
  created() {
    this.$emit(`update:layout`, FullPageLayout);
  }
};
</script>
